import type {ReactElement} from 'react';
import React from 'react';
import {ContextualMenuControlsOption} from '@Components/contextual-menu/components/contextual-menu-controls-option';
import {openPosterItemsListModal} from '@Modals/poster-items-list-modal';
import {onTestButton, onTestButton2} from '@PosterWhiteboard/poster/poster-editor-shortcuts';
import {openEditorPosterTools} from '@Components/poster-editor/library/poster-editor-library';
import {SuperUserPosterControlOptions} from './super-user-poster-controls.types';

export function SuperUserPosterControls(): ReactElement<any> {
  const onOpenPosterTools = (): void => {
    openEditorPosterTools();
  };

  const onShowItemsList = (): void => {
    openPosterItemsListModal();
  };

  const onClickHandler = (id: SuperUserPosterControlOptions): void => {
    switch (id) {
      case SuperUserPosterControlOptions.ITEMS_LIST:
        onShowItemsList();
        return;
      case SuperUserPosterControlOptions.POSTER_TOOLS:
        onOpenPosterTools();
        return;
      case SuperUserPosterControlOptions.TEST:
        void onTestButton();
        return;
      case SuperUserPosterControlOptions.TEST2:
        void onTestButton2();
        return;
      default:
        throw new Error('unhandled poster item control option!');
    }
  };

  return (
    <ContextualMenuControlsOption
      id="poster-item-controls"
      onClick={onClickHandler}
      isCenterAligned
      data={[
        {
          id: SuperUserPosterControlOptions.ITEMS_LIST,
          icon: 'icon-templates-stack',
          text: window.i18next.t('pmwjs_items_list'),
          wrapText: true,
        },
        {
          id: SuperUserPosterControlOptions.POSTER_TOOLS,
          icon: 'icon-info',
          text: window.i18next.t('pmwjs_poster_tools'),
          wrapText: true,
        },
        {
          id: SuperUserPosterControlOptions.TEST,
          icon: 'icon-screen-rocket',
          text: window.i18next.t('pmwjs_test'),
          wrapText: true,
        },
        {
          id: SuperUserPosterControlOptions.TEST2,
          icon: 'icon-screen-rocket',
          text: window.i18next.t('pmwjs_test_2'),
          wrapText: true,
        },
      ]}
    />
  );
}
